module.exports = __webpack_public_path__ + "img/zbd-left-bg.2f7be37c.png";